import { LoanForm } from './LoanForm';
import type { SchemaCreditRequestForm } from '../../../schemas/creditRequestForm.schema';
import { LEASING, type LEASING_TYPE } from '../../../types';
import { headers } from '../../constants';
import LoanCard from '../shared/LoanCard';

type Props = {
    credit: SchemaCreditRequestForm[LEASING_TYPE][number];
    index: number;
};

export const DetailedView = ({ credit, index }: Props) => (
    <td colSpan={headers.length} className="p-3">
        <LoanCard name={`${LEASING}.${index}`} credit={credit}>
            <LoanForm index={index} applicant={credit.gehoertZuAntragsteller} />
        </LoanCard>
    </td>
);
